// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentBox_wrapper__15vvt","overlay":"ContentBox_overlay__2gXdQ"};